import { useState, useRef, useEffect } from 'react';
import { Category, TestResult } from '../../types';
import { exportFullReportCSV, exportFullReportExcel } from '../../services/scenarioService';

export function useTestManagerExport(categories: Category[], currentTest: TestResult | null) {
  const [isExportMenuOpen, setIsExportMenuOpen] = useState(false);
  const exportMenuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (exportMenuRef.current && !exportMenuRef.current.contains(event.target as Node)) {
        setIsExportMenuOpen(false);
      }
    };

    if (isExportMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isExportMenuOpen]);

  const exportFullReportCSVWrapper = () => {
    if (currentTest) {
      exportFullReportCSV(categories, currentTest.filename, currentTest);
      setIsExportMenuOpen(false);
    }
  };

  const exportFullReportExcelWrapper = () => {
    if (currentTest) {
      exportFullReportExcel(categories, currentTest.filename, currentTest);
      setIsExportMenuOpen(false);
    }
  };

  return {
    isExportMenuOpen,
    setIsExportMenuOpen,
    exportMenuRef,
    exportFullReportCSVWrapper,
    exportFullReportExcelWrapper,
  };
}
